<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-15 16:36:23
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2023-12-21 11:31:32
 * @Description: description
-->
<template>
  <section class="footer-panel">
    <div class="footer-panel-center">
      <span title="推荐使用浏览器" class="browser-recommend">
        推荐使用浏览器:
        <span>
          <img
            @click="
              handleOpenNewPage('https://www.google.cn/intl/zh-CN/chrome/')
            "
            title="点击下载"
            src="../../../static/images/browser/chrome-icon.png"
          />
        </span>
        <span>
          <img
            @click="handleOpenNewPage('http://www.firefox.com.cn/')"
            title="点击下载"
            src="../../../static/images/browser/firefox-icon.png"
          />
        </span>
        <span>
          <img
            @click="handleOpenNewPage('https://browser.360.cn/se/')"
            title="点击下载"
            src="../../../static/images/browser/360-icon.png"
          />
        </span>
      </span>
      <span title="技术支持单位:广东华际友天信息科技有限公司"
        >技术支持单位:广东华际友天信息科技有限公司</span
      >
      <span title="工作时间:8:30-17:30">工作时间:8:30-17:30</span>
      <span title="办公联系方式:020-38468111">办公联系方式:020-38468111</span>
    </div>
  </section>
</template>

<script>
export default {
  name: "FooterComponent",
  methods: {
    handleOpenNewPage(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-panel {
  font-size: 14px;
  background: url(../../../static/images/bgimage.png);
  padding: 5px;
  color: #606060;
  text-align: center;
  &-center {
    display: flex;
    width: calc(min(1200px, 100%));
    margin: 2px auto;
    & > span {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .browser-recommend {
      display: flex;
      justify-content: center;
      & > span {
        display: inline-block;
        width: 20px;
        height: 20px;
      }
      img {
        cursor: pointer;
        width: 100%;
        height: 100%;
        padding: 2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/FooterComponent.vue